import React, { useState } from 'react';
import Button3D from '../../ui/Button3D';
import Switch from '../../ui/Switch';
import { settingsSubtitle } from '../eventSettings';
import { resolveEventWords } from '../eventWords';
import SettingsPopup from './SettingsPopup';

function ToggleRow({ id, label, checked, onChange, note, disabled = false }) {
    return (
        <li className="ia-resv-field ia-resv-field--wide" data-testid={`toggle-${id}`}>
            <div className="flex items-center justify-between gap-3">
                <span id={`${id}-label`} className="text-sm font-bold">{label}</span>
                <Switch id={id} checked={checked} onChange={onChange} aria-label={label} describedBy={`${id}-note`} disabled={disabled} />
            </div>
            <p id={`${id}-note`} className="ia-resv-field__why">{note}</p>
        </li>
    );
}

// Module 19 (BL-380) G5 - "Check-In": whether guests are checked in at the door, and whether that uses QR passes and the door scanner.
// Turning either off hides it everywhere and the database refuses it too; nothing already stored (check-ins, passes, history) is deleted.
export default function CheckInSettingsPopup({ settings, saving, error, onSave, onClose }) {
    const [form, setForm] = useState({ checkin_enabled: settings.checkin_enabled !== false, checkin_qr_enabled: settings.checkin_qr_enabled !== false });
    const words = resolveEventWords(settings);
    const flip = (name) => (value) => setForm((previous) => ({ ...previous, [name]: value }));
    const submit = (event) => { event?.preventDefault?.(); onSave({ ...settings, ...form }); };
    return (
        <SettingsPopup
            title="Check-In"
            subtitle={settingsSubtitle(words)}
            tileKey="check-in"
            testId="events-settings-checkin"
            onClose={onClose}
            actions={(
                <>
                    <Button3D onClick={onClose} disabled={saving}>Cancel</Button3D>
                    <Button3D variant="go" onClick={submit} disabled={saving}>{saving ? 'Saving…' : 'Save'}</Button3D>
                </>
            )}
        >
            <form onSubmit={submit} noValidate>
                <ul className="ia-resv-grid" aria-label="Check-in">
                    <ToggleRow id="set-checkin" label="Check guests in at the door" checked={form.checkin_enabled} onChange={flip('checkin_enabled')}
                        note={`Staff with Events edit rights mark who arrived. Each ${words.eventLower} shows checked in, expected, walk-ins and, once it is over, no-shows, with a report to download.`} />
                    <ToggleRow id="set-checkin-qr" label="QR passes and the door scanner" checked={form.checkin_enabled && form.checkin_qr_enabled} onChange={flip('checkin_qr_enabled')} disabled={!form.checkin_enabled}
                        note="Every guest gets a QR pass (it holds only a random code, never a name or contact details) and staff scan it with a phone or tablet camera. Off: staff check guests in from the list only." />
                </ul>
                <p className="mt-3 text-sm">Turning one off hides it. Nothing already saved is deleted.</p>
                {error && <p className="ia-resv-error" role="alert">{error}</p>}
            </form>
        </SettingsPopup>
    );
}
